export class Cache {
  map = new Map<string, { value: any; expire: number }>();
  constructor() {}

  get(key: string) {
    const cacheData = this.map.get(key);
    if (cacheData) {
      if (Date.now() > cacheData.expire) {
        return false;
      }

      return cacheData.value;
    }
    return false;
  }

  set(
    key: string,
    value: any,
    { expireTime = 60000 }: { expireTime?: number } = {}
  ) {
    this.map.set(key, { value, expire: Date.now() + expireTime });
  }

  generateKey(param: any) {
    return JSON.stringify(param);
  }
}
